import { Alert, Box, LinearProgress } from "@mui/material";
import GenericSelectLayout, { SelectType } from "../../components/GenericSelectLayout";
import styles from "../SelectClient/SelectClient.module.css";
import { useClientAccessContext } from "../../context/ClientAccessContext";
import { useConfig } from "../../context/ConfigContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../router/routes";

const SelectTopic = () => {
  const { selectedClient } = useClientAccessContext();
  const { loadingTopics, usersTopics, setSelectedTopic, selectedTopic, fromNavBar, setFromNavBar } = useConfig();
  const navigate = useNavigate();

  useEffect(() => {
    if (!selectedClient) {
      navigate(routes.selectClient);
    }
  }, [selectedClient, navigate]);

  useEffect(() => {
    if (!fromNavBar && selectedTopic) {
      navigate(routes.overview);
    }
    if (!fromNavBar && usersTopics.length === 1) {
      handleSelectTopic(usersTopics[0]);
    }
  }, [fromNavBar, selectedTopic, navigate]);

  const handleSelectTopic = (topic) => {
    setFromNavBar(false);
    setSelectedTopic(topic);
  };

  if (loadingTopics) {
    return (
      <Box>
        <LinearProgress />
      </Box>
    );
  }

  return (
    <>
      {usersTopics?.length ? (
        <div className={styles.container}>
          <GenericSelectLayout
            type={SelectType.Topic}
            items={usersTopics}
            onCardClick={(topic) => handleSelectTopic(topic)}
          />
        </div>
      ) : (
        <Alert severity="info">You do not have any topic access</Alert>
      )}
    </>
  );
};

export default SelectTopic;
